import * as React from 'react';
import classNames from 'classnames';
import { ConfigurationModel, ConfigurationDefaultModel, TYPE_OF_INSTALLATION } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { Button } from 'reactstrap';
import { WarningsTooltip } from '../../Warnings';
import { isConfigurationEditable } from 'src/redux/utils.redux';
import ConsolesOverlapChoice from '../Assemblies/ConsoleOverlapChoice';

export interface TypeOfInstallationProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  warning: GlobalPrivateState['warning'];
}

export class TypeOfInstallationPartial extends React.Component<TypeOfInstallationProps, any> {
  constructor(props: TypeOfInstallationProps) {
    super(props); 
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const {
      warning,
    } = this.props;
    
    return (
      <div className="partial-installation position-relative">
        {isConfigurationEditable() && (
          <WarningsTooltip itemKey="typeOfInstallation" />
        )}
        <ConsolesOverlapChoice id="typeOfInstallationOverlap" />
        <div className="row">
          {this.defaults && this.defaults.map((item, index) => {
            const key = `partial_installation_item_${index}`;
            const isSelected = this.selected === item;
            const disabled = warning.requireReset.typeOfInstallation.required
              || !isConfigurationEditable()
              || isSelected;

            return (
              <div key={key} className="col-6 col-sm-6 col-md-3">
                <Button 
                  className={classNames('p-0', 'btn', 'border-0', 'display-block', `item-${item}`, {'active' : isSelected})}
                  onClick={() => this.handleClick(item)} 
                  disabled={disabled}>
                  <span className="item">{item}</span>
                  <span className={isSelected ? 'box-installation active' : 'box-installation'} />
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  private get defaults(): ConfigurationDefaultModel['washBasinDimension']['typeOfInstallation']['values'] | undefined {
    const configurationDefaults = this.props.configuration.result && this.props.configuration.result.defaults;
    return configurationDefaults && 
      configurationDefaults && 
      configurationDefaults.washBasinDimension.typeOfInstallation && 
      configurationDefaults.washBasinDimension.typeOfInstallation.values;
  }

  private handleClick(type: TYPE_OF_INSTALLATION) {
    const { configuration } = this.props;

    if (!isConfigurationEditable()) { return; }

    if (configuration && configuration.result && configuration.result.washBasinDimension) {
      
      const defaults = configuration.result && configuration.result.washBasinDimension;
      const data: ConfigurationModel['washBasinDimension'] = defaults as ConfigurationModel['washBasinDimension'];
      if (data) {
        data.typeOfInstallation = type;

        if (type === 'with') {
          data.plateDimensionsAcceptedNicheTip = false;
        } else {
          data.plateDimensionsAcceptedNicheTip = true;
        }

        this.props.dispatch(requestAPIActions.load(
          'configuration',
          {
            url: `/Configurations/${configuration.result.id}`,
            options: {
              method: 'PATCH',
              data: {washBasinDimension: data}
            },
          },
          true
        ));
      }
    }
  }

  private get selected(): TYPE_OF_INSTALLATION | undefined {
    const {
      configuration
    } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.washBasinDimension && 
      configuration.result.washBasinDimension.typeOfInstallation ? configuration.result.washBasinDimension.typeOfInstallation : undefined;
  }
}

export const TypeOfInstallation = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  warning: state.warning,
}))(TypeOfInstallationPartial);

export default TypeOfInstallation;
